export default __webpack_public_path__ + "static/media/AlianzasClaves_Icon.aff120c1.svg";